'use client';

import { c as _c } from "react/compiler-runtime";
import dayjs from 'dayjs';
import { useTranslations } from 'next-intl';
import { useEffect, useRef, useState } from 'react';
interface UseCountdownTimerOptions {
  updateInterval?: number;
  isStarted?: boolean;
}
export const useCountdownTimer = (dateString, t0) => {
  const $ = _c(8);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    updateInterval: t2,
    isStarted: t3
  } = t1;
  const updateInterval = t2 === undefined ? 1000 : t2;
  const isStarted = t3 === undefined ? true : t3;
  const t = useTranslations("timer");
  const [displayText, setDisplayText] = useState("");
  const intervalRef = useRef(null);
  let t4;
  let t5;
  if ($[2] !== dateString || $[3] !== isStarted || $[4] !== t || $[5] !== updateInterval) {
    t4 = () => {
      const updateTimer = () => {
        const now = dayjs();
        const targetDate = dayjs(dateString instanceof Date ? dateString.toISOString() : dateString);
        const diffMs = targetDate.diff(now, "millisecond");
        if (diffMs <= 0) {
          setDisplayText("");
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
          return;
        }
        const totalSeconds = Math.floor(diffMs / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor(totalSeconds % 86400 / 3600);
        const minutes = Math.floor(totalSeconds % 3600 / 60);
        const formatTime = _temp;
        let formatted;
        const label = isStarted ? t("endsIn") : t("startsIn");
        if (days >= 1) {
          formatted = `${label} ${days}${t("d")} : ${formatTime(hours)}${t("h")}`;
        } else {
          formatted = `${label} ${formatTime(hours)}${t("h")} : ${formatTime(minutes)}${t("m")}`;
        }
        setDisplayText(formatted);
      };
      updateTimer();
      intervalRef.current = setInterval(updateTimer, updateInterval);
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      };
    };
    t5 = [dateString, updateInterval, isStarted, t];
    $[2] = dateString;
    $[3] = isStarted;
    $[4] = t;
    $[5] = updateInterval;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  if (!dateString) {
    return null;
  }
  return displayText || null;
};
function _temp(value) {
  return String(value).padStart(2, "0");
}